module.exports = __webpack_public_path__ + "static/media/login_logo.73f2180c.svg";